import { Avatar } from "@vega-core/components/Avatar/Avatar";
import { isTruthy } from "@vega-core/utils/isTruthy";

export type InvitationCellProps = {
  email: string;
  status?: string;
};

export const InvitationCell = ({ email, status }: InvitationCellProps) => (
  <div className="flex items-center gap-4">
    <Avatar initials={email[0]} variant="secondary" />
    <div>
      <div className="text-text/secondary body-small-regular">
        {email} {isTruthy(status) ? <>({status})</> : null}
      </div>
    </div>
  </div>
);
